// 상세이미지 특정 장 빼기·바꾸기(rocket.sourcing.setDetailImages · PR261021-1B9947)
// runWork 뒤 쿠팡에 가는 것은 낱장을 이어 붙인 통합 이미지 1장(detailImages·coupangDoc detailedImage)이고 낱장은 processedDetailImages 에만 있다.
// 그래서 낱장에서 빼기·바꾸기를 한 뒤 통합 이미지를 runWork(detailImageService process)와 같은 HTML 로 다시 만들어야 쿠팡 쪽이 바뀐다.
// 그리기(html2canvas)·S3 올림은 화면 몫 — 여기는 꾸러미 없이 잴 수 있는 것만.

/** 장 목록 — 설정(상·하단) 이미지는 빼고 index 순 · 장 번호(no)는 1부터 */
function contentImages(product) {
  const list = (product && Array.isArray(product.processedDetailImages)) ? product.processedDetailImages : []
  return list.filter(x => x && x.url && !x.isSettingImage).slice().sort((a, b) => a.index - b.index)
}

export function detailImageList(product) {
  return contentImages(product).map((x, i) => ({ no: i + 1, url: x.url, originalUrl: x.originalUrl || null }))
}

export function hasDetailImageEdit(params) {
  const p = params || {}
  return (Array.isArray(p.remove) && p.remove.length > 0) || (Array.isArray(p.replace) && p.replace.length > 0)
}

/** https 이미지 주소인가 — 따옴표·꺾쇠·빈칸이 들면 거절(MCP 인자가 HTML 속성으로 들어가므로 · saram 10-23 XSS) */
export function isSafeHttpsUrl(u) {
  if (typeof u !== 'string' || !/^https:\/\/[^/]/.test(u) || /["'<>`\s\\]/.test(u)) return false
  try { const x = new URL(u); return x.protocol === 'https:' && !!x.hostname } catch (e) { return false }
}

/** HTML 속성 값 escape */
function attr(v) {
  return String(v == null ? '' : v).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/'/g, '&#39;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
}

/** 도구 인자 잣대 — 어긋나면 사람이 읽을 말로 던진다 */
export function checkDetailImageEditInput(params) {
  const p = params || {}
  if (typeof p.registrationId !== 'string' || !p.registrationId.trim()) throw new Error('대상 상품의 등록ID(registrationId)를 주세요.')
  if (p.remove !== undefined && p.remove !== null && !Array.isArray(p.remove)) throw new Error('remove 는 뺄 장 번호 목록이어야 합니다(예: [2, 5]).')
  if (p.replace !== undefined && p.replace !== null && !Array.isArray(p.replace)) throw new Error('replace 는 [{no, imageUrl}] 목록이어야 합니다.')
  const isNo = n => Number.isInteger(n) && n >= 1
  const seen = new Set()
  const take = (n) => {
    if (!isNo(n)) throw new Error(`장 번호는 1 이상 정수입니다(받은 값: ${JSON.stringify(n)}).`)
    if (seen.has(n)) throw new Error(`${n}번 장을 두 번 지정했습니다 — 빼기와 바꾸기 중 하나만 주세요.`)
    seen.add(n)
  }
  ;(p.remove || []).forEach(take)
  ;(p.replace || []).forEach(r => {
    take(r && r.no)
    const u = r && typeof r.imageUrl === 'string' ? r.imageUrl.trim() : ''
    if (!isSafeHttpsUrl(u)) throw new Error(`${r.no}번 장을 바꿀 이미지 주소(imageUrl)는 https 주소여야 합니다.`)
  })
}

/** 빼기·바꾸기를 한 새 낱장 목록 — 받은 상품은 안 바꾼다 · 바꾼 장은 번역 칸을 버린다(옛 글로 경고가 남지 않게) */
export function applyDetailImageEdit(product, params) {
  const list = contentImages(product)
  if (!list.length) throw new Error('이 상품은 상세이미지 작업 결과가 없습니다 — rocket.sourcing.runWork 로 detailImage 작업을 먼저 끝내세요.')
  const remove = params.remove || []
  const replace = params.replace || []
  const bad = [...remove, ...replace.map(r => r.no)].filter(n => n > list.length)
  if (bad.length) throw new Error(`${bad.join(', ')}번 장은 없습니다 — 이 상품의 상세이미지는 ${list.length}장입니다.`)
  if (remove.length >= list.length) throw new Error('상세이미지를 전부 뺄 수는 없습니다 — 한 장 이상 남겨 주세요.')
  const byNo = new Map(replace.map(r => [r.no, r.imageUrl.trim()]))
  const images = []
  list.forEach((x, i) => {
    const no = i + 1
    if (remove.includes(no)) return
    const url = byNo.get(no)
    images.push(url ? { index: images.length, url, originalUrl: url } : { ...x, index: images.length })
  })
  return { images, before: list.length, removed: remove.slice().sort((a, b) => a - b), replaced: [...byNo.keys()].sort((a, b) => a - b) }
}

/** 통합 이미지 HTML — detailImageService process 의 병합 HTML 과 같은 꼴(800px · 상단 → 낱장 → 하단) */
export function combinedDetailHtml(urls, settings) {
  const s = settings || {}
  const block = (src, alt) => `
        <div style="margin:0; padding:0; text-align:center; width:800px;">
          <img src="${attr(src)}" alt="${attr(alt)}" style="width:800px; display:block; margin:0 auto; padding:0;" width="800">
        </div>`
  let html = '<div style="width:800px; margin:0; padding:0; background-color:#ffffff; box-sizing:border-box;">'
  if (s.useTopImage && s.topImageUrl) html += block(s.topImageUrl, '상단 이미지')
  urls.forEach((u, i) => { html += block(u, `상세 이미지 ${i + 1}`) })
  if (s.useBottomImage && s.bottomImageUrl) html += block(s.bottomImageUrl, '하단 이미지')
  return html + '</div>'
}

/** 통합 이미지 그리기·올림 실패 글 — 서버 까닭(본문 message·alert·error · DetailImageEdit serverReason 과 같은 잣대)을 싣고 저장 전이라 바뀐 것 0 을 밝힌다 */
export function detailUploadFailText(error) {
  const data = error && error.response && error.response.data
  const reason = (data && (data.message || data.alert || data.error)) || (error && error.message) || '알 수 없는 오류'
  return `상세이미지 통합 그림을 그리거나 올리지 못해 저장하지 않았습니다(바뀐 것은 없습니다): ${reason}`
}

/** 저장 칸 — DetailImageEdit applyDetailToOneProduct 와 같은 자리(상품·등록문서·옵션) · 상태 글은 지금 값 그대로(일부완료를 완료로 올리지 않음) */
export function detailEditUpdateFields(product, { images, combinedUrl, claimWarning }) {
  const urls = [combinedUrl]
  const fields = {
    processedDetailImages: images,
    detailImages: urls,
    detailHtml: `
        <div style="width:100%; max-width:800px; margin:0 auto; background-color:#ffffff; padding:0;">
          <div style="text-align:center;">
            <img src="${attr(combinedUrl)}" alt="상세 이미지" style="max-width:100%; width:800px; display:block; margin:0 auto;">
          </div>
        </div>`,
    detailImageStatusObj: { status: product.detailImageStatus || 'completed', images: [...urls] },
    detailClaimWarning: claimWarning,
    lastModified: new Date(),
  }
  const docs = (product.coupangDoc && product.coupangDoc.jsonDocument) || []
  docs.forEach((doc, i) => {
    if (doc && doc.imagePage && doc.imagePage.details) {
      fields[`coupangDoc.jsonDocument.${i}.imagePage.details.detailedImage`] = combinedUrl
      fields[`coupangDoc.jsonDocument.${i}.imagePage.details.htmlProductDetailContent`] = ''
    }
  })
  ;(product.options || []).forEach((option, i) => {
    fields[`options.${i}.detailImages`] = [...urls]
    const d = option && option.coupangDoc && option.coupangDoc.jsonDocument && option.coupangDoc.jsonDocument[0]
    if (d && d.imagePage && d.imagePage.details) {
      fields[`options.${i}.coupangDoc.jsonDocument.0.imagePage.details.detailedImage`] = combinedUrl
      fields[`options.${i}.coupangDoc.jsonDocument.0.imagePage.details.htmlProductDetailContent`] = ''
    }
  })
  return fields
}
